// utils/validation.js

export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const phoneRegex = /^[+]?[0-9\s]{7,15}$/;

export const emailValidation = {
    required: "Please provide an email.",
    pattern: {
        value: emailRegex,
        message: "Please enter a valid email address.",
    },
};

export const phoneValidation = {
    required: "Please provide a phone number.",
    pattern: {
        value: phoneRegex,
        message: "Please enter a valid phone number",
    },
};

export const requiredField = (fieldName) => ({
    required: `Please provide ${fieldName}.`,
});
